import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Avatar,
} from '@mui/material';
import { ExitToApp, Person } from '@mui/icons-material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/img/logo_constructora.png';
import { LAYOUT_CONFIG } from '../constants/layoutConstants';
import { useAuth } from '../../hooks/useAuth';
import { useLastBackupLog } from '../../hooks/useBackupLogs';
import NotificationsBell from './NotificationsBell';

const AppHeader = () => {
  const navigate = useNavigate();
  const { clearToken, user } = useAuth();
  const { data: lastBackupLog } = useLastBackupLog();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleMenuClose();
    clearToken();

    navigate('/');
  };

  let backupWarning = null;
  if (lastBackupLog) {
    const backupDate = new Date(lastBackupLog.created_at);
    const now = new Date();
    const diffDays = (now - backupDate) / (1000 * 60 * 60 * 24);
    if (diffDays > 2) {
      backupWarning = (
        <Typography variant="body2" color="error" sx={{ fontWeight: 600 }}>
          ⚠️ No se ha realizado un respaldo en más de 2 días. Avisar al equipo de desarrollo.
        </Typography>
      );
    }
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: 'background.paper',
        boxShadow: 'none',
        borderColor: 'divider',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        height: LAYOUT_CONFIG.desktop.headerHeight,
      }}
    >
      <Toolbar sx={{ height: '100%', justifyContent: 'space-between' }}>
        <Box
          component="a"
          href="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
          }}
        >
          <img
            src={logo}
            alt="Logo Constructora"
            style={{
              height: '42px',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Box>
          {lastBackupLog ? (
            <>
              <Typography variant="body2" color="text.secondary">
                Último respaldo:{' '}
                {new Date(
                  new Date(lastBackupLog.created_at).getTime() - 3 * 60 * 60 * 1000
                ).toLocaleString()}
              </Typography>
              {backupWarning}
            </>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Cargando último respaldo...
            </Typography>
          )}
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <NotificationsBell />

          {user?.names ? (
            <Typography
              variant="body2"
              sx={{
                display: { xs: 'none', sm: 'block' },
                color: 'text.secondary',
                fontWeight: 600,
                textTransform: 'capitalize',
              }}
            >
              {user.names}
            </Typography>
          ) : null}

          <IconButton
            onClick={handleMenuOpen}
            sx={{
              p: 0.5,
              bgcolor: anchorEl ? 'action.selected' : 'transparent',
              '&:hover': {
                bgcolor: 'action.hover',
              },
            }}
          >
            <Avatar sx={{ width: 36, height: 36, bgcolor: 'primary.main' }}>
              <Person />
            </Avatar>
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            PaperProps={{
              sx: {
                mt: 1,
                minWidth: 180,
                boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
                border: '1px solid',
                borderColor: 'divider',
              },
            }}
          >
            <MenuItem
              onClick={handleLogout}
              sx={{
                gap: 2,
                color: 'error.main',
                '&:hover': {
                  bgcolor: 'error.light',
                  color: 'error.contrastText',
                },
              }}
            >
              <ExitToApp fontSize="small" />
              Cerrar sesión
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader;
